import * as React from "react";
import Grid, { GridProps } from "@mui/material/Grid";

const GridItem = (
  props: GridProps & { xs?: number; sm?: number; md?: number; lg?: number },
) => {
  const { xs = 12, sm, md, lg, ...rest } = props;

  return (
    <Grid size={{ xs, sm, md, lg }} {...rest}>
      {props.children}
    </Grid>
  );
};

export default GridItem;
